gsap.registerPlugin(SplitText);
window.addEventListener('load', function(){
    setTimeout(() => {
        const theSlider = document.querySelector('.mag-stories__slider');
        const cards = document.querySelectorAll('.mag-stories .mag-stories__card');
        const navLinks = document.querySelectorAll('.mag-stories__page');
        let currentIndex = 0;
        let startX = 0;
        let startY = 0;
        let isSwiping = false;

        const tlStories = gsap.timeline();

        // Cards slider
        function updateActiveNav(index) {
            navLinks.forEach(link => link.classList.remove('active'));
            navLinks[index].classList.add('active');
        }

        function showNextCard(index) {
            if (index === currentIndex) return;

            const currentCard = cards[currentIndex];
            const nextCard = cards[index];

            // Animate current card out (to the left, fade out)
            tlStories.to(currentCard, {
                duration: 0.3,
                rotation: 10,
                y: 20,
                x: 20
            })
            .to('.mag-stories__fakecard--1', {
                duration: 0.3,
                rotation: 10,
                y: 20,
                x: 20
            }, '<')
            .to('.mag-stories__fakecard--2', {
                duration: 0.3,
                rotation: 12
            }, '<')
            .to('.mag-stories__fakecard--3', {
                duration: 0.3,
                rotation: 14
            }, '<')
            .to(currentCard, {
                duration: 0.5,
                x: -500,
                opacity: 0,
                rotation: -10,
                onComplete: () => {
                    gsap.set(currentCard, {
                        x: 0,
                        y: "100%",
                        rotation: 0,
                        opacity: 0
                    });
                }
            })
            .to('.mag-stories__fakecard--1', {
                duration: 0.3,
                rotation: 0,
                y: 0,
                x: 0
            }, '<')
            .to('.mag-stories__fakecard--2', {
                duration: 0.3,
                rotation: 6,
                y: 0,
                x: 0
            }, '<')
            .to('.mag-stories__fakecard--3', {
                duration: 0.3,
                rotation: 12,
                x: 0
            }, '<')
            .fromTo(nextCard, {
                rotation: 10,
                y: 20,
                x: 20,
                opacity: 0,
                zIndex: 10
            }, {
                duration: 0.3,
                y: 0,
                x: 0,
                rotation: 0,
                opacity: 1,
                zIndex: 10
            }, '<');

            currentIndex = index; // Update the current index
            updateActiveNav(currentIndex); // Update the active nav link
        }

        // Handle navigation link clicks
        navLinks.forEach((link, index) => {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                const targetSlide = link.getAttribute('data-toggle');
                const targetIndex = Array.from(cards).findIndex(card => card.getAttribute('data-slide') === targetSlide);

                if (targetIndex !== -1) {
                    showNextCard(targetIndex);
                }
            });
        });

        // Handle clicking on the nav (next card)
        document.querySelector('.mag-stories__nav').addEventListener('click', (e) => {
            e.preventDefault();
            const nextIndex = (currentIndex + 1) % cards.length; // Loop back to first card
            showNextCard(nextIndex);
        });

        // Set initial active nav link
        updateActiveNav(currentIndex);

        // Add swipe handling and prevent vertical scroll during swipe
        theSlider.addEventListener('touchstart', function(e) {
            startX = e.touches[0].clientX;
            startY = e.touches[0].clientY;
            isSwiping = false; // Reset swipe state
        });

        theSlider.addEventListener('touchmove', function(e) {
            const moveX = e.touches[0].clientX - startX;
            const moveY = e.touches[0].clientY - startY;

            // Determine if the swipe is horizontal
            if (Math.abs(moveX) > Math.abs(moveY)) {
                isSwiping = true;
                e.preventDefault(); // Prevent vertical scrolling if swiping horizontally
            }
        });

        theSlider.addEventListener('touchend', function(e) {
            if (isSwiping) {
                // Swipe was horizontal, move to the next card
                const nextIndex = (currentIndex + 1) % cards.length;
                showNextCard(nextIndex);
            }
        });
    });
});
